<script>
    import { Line } from 'vue-chartjs';
    import { mapGetters } from 'vuex';

    export default {
        extends: Line,
        data() {
            return {
                options: {
                    spanGaps: true,
                    tooltips: {
                        callbacks: {
                            title: () => '',
                            label: (item, data) =>
                                data.datasets[item.datasetIndex].label,
                            afterLabel: () => ''
                        },
                        backgroundColor: 'transparent',
                        tooltipEvents: [
                            'mousemove',
                            'touchstart',
                            'touchmove',
                            'click'
                        ],
                        titleFontSize: 16,
                        titleFontColor: '#fff',
                        bodyFontColor: '#fff',
                        bodyFontSize: 14,
                        displayColors: false
                    },
                    layout: {
                        padding: {
                            top: 20,
                            bottom: 0
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                title: {
                                    font: {
                                        weight: 'bold'
                                    }
                                },
                                weight: 100,
                                gridLines: {
                                    color: [
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)'
                                    ],
                                    zeroLineWidth: 0,
                                    zeroLineColor: 'rgba(255, 255, 255, 0)',
                                    drawBorder: false
                                },
                                ticks: {
                                    fontColor: '#ffffff',
                                    fontSize: 10,
                                    padding: 14,
                                    min: 1,
                                    max: 100,
                                    stepSize: 25,
                                    callback: label => {
                                        const moods = this.$t(
                                            'statistics.moodLabels'
                                        );
                                        switch (label) {
                                            case 1:
                                                return ['SUPER', 'STRESSED'];
                                            case 25:
                                                return moods[3];
                                            case 50:
                                                return [
                                                    'SOMEWHERE',
                                                    'IN BETWEEN'
                                                ];
                                            case 75:
                                                return moods[1];
                                            case 100:
                                                return ['COMPLETELY', 'CHILL'];
                                        }
                                    }
                                }
                            }
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    color: 'rgba(255, 255, 255, 0)',
                                    tickMarkLength: 15,
                                    zeroLineWidth: 1,
                                    zeroLineColor: 'rgba(255, 255, 255, 0)',
                                    drawBorder: false
                                },
                                ticks: {
                                    fontColor: '#ffffff',
                                    fontSize: 12,
                                    padding: 5,
                                    min: 1,
                                    max: 31,
                                    step: 5
                                }
                            }
                        ]
                    },
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    bezierCurve: false
                }
            };
        },
        computed: {
            ...mapGetters('statistics', ['dataCollection', 'counter'])
        },
        watch: {
            ['dataCollection.labels']() {
                this.renderChart(this.dataCollection, this.options);
            },
            ['dataCollection.updated']() {
                this.renderChart(this.dataCollection, this.options);
            },
            counter() {
                this.renderChart(this.dataCollection, this.options);
            }
        },
        mounted() {
            setTimeout(() => {
                this.renderChart(this.dataCollection, this.options);
            }, 500);
        }
    };
</script>
